<template>
    <v-container fluid>
        <v-card flat>
            <v-card-title class="text-h5 dialog-title">
                {{ producto.id ? "Editar" : "Crear" }} Producto
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="8">
                        <v-card class="mt-3">
                            <v-card-title
                                ><h3>Datos del producto</h3></v-card-title
                            >
                            <v-card-text>
                                <v-form
                                    ref="form"
                                    v-model="formValid"
                                    class="mt-3"
                                >
                                    <v-row>
                                        <v-col cols="12" md="3" sm="6">
                                            <v-text-field
                                                label="Nombre"
                                                v-model="producto.nombre"
                                                outlined
                                                dense
                                                :rules="[rules.required]"
                                            >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="3" sm="6">
                                            <v-text-field
                                                label="Precio de alta"
                                                type="number"
                                                v-model="producto.precio"
                                                outlined
                                                dense
                                                suffix="€"
                                                :rules="[rules.required]"
                                            >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="3" sm="6">
                                            <v-text-field
                                                label="Minutos"
                                                type="number"
                                                v-model="producto.minutos"
                                                outlined
                                                dense
                                                :rules="[rules.required]"
                                            >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="3" sm="6">
                                            <v-autocomplete
                                                label="Modulo"
                                                v-model="producto.id_modulo"
                                                :items="modulos"
                                                item-text="nombre"
                                                item-value="id"
                                                outlined
                                                dense
                                                :rules="[rules.required]"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea
                                                label="Descripción"
                                                v-model="producto.descripcion"
                                                outlined
                                                dense
                                                auto-grow
                                            >
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-card class="mt-3">
                            <v-card-title
                                ><h3>Tarifas del producto</h3></v-card-title
                            >
                            <v-card-text>
                                <v-form
                                    ref="formPrecios"
                                    v-model="formValid_precios"
                                    class="mt-3"
                                >
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field
                                                label="Descripción"
                                                v-model="
                                                    producto_precio.descripcion
                                                "
                                                outlined
                                                dense
                                                :rules="[rules.required]"
                                            />
                                        </v-col>

                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                label="Precio"
                                                v-model="producto_precio.precio"
                                                outlined
                                                dense
                                                :rules="[rules.required]"
                                                suffix="€"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                label="Precio Anual"
                                                v-model="producto_precio.precio_anual"
                                                outlined
                                                dense
                                                suffix="€"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-text-field
                                                label="Nº Mínimo Us."
                                                type="number"
                                                v-model="producto_precio.min_usuarios"
                                                outlined
                                                dense
                                            />
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-text-field
                                                label="Nº Máximo Us"
                                                type="number"
                                                v-model="producto_precio.num_max_usuarios"
                                                outlined
                                                dense
                                            />
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-checkbox
                                                :label="
                                                    producto_precio.fijo
                                                        ? 'Fijo'
                                                        : 'Variable'
                                                "
                                                v-model="producto_precio.fijo"
                                                outlined
                                                dense
                                            />
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-checkbox
                                                label="Pago Único"
                                                v-model="producto_precio.pago_unico"
                                                outlined
                                                dense
                                            />
                                        </v-col>


                                        <v-col
                                            cols="12"
                                            class="d-flex flex-column gap-2"
                                        >
                                            <v-tooltip top>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-btn
                                                        style="width: 100%"
                                                        color="success"
                                                        class="white--text"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="
                                                            addPrecioProducto
                                                        "
                                                    >
                                                        <v-icon color="white">
                                                            {{
                                                                editingPrecioIndex !== null
                                                                    ? 'mdi-content-save'
                                                                    : 'mdi-plus'
                                                            }}
                                                        </v-icon>
                                                        {{
                                                            editingPrecioIndex !== null
                                                                ? 'Actualizar tarifa'
                                                                : 'Añadir tarifa'
                                                        }}
                                                    </v-btn>
                                                </template>
                                                <span>
                                                    Añadir configuraciones de
                                                    precios para este producto
                                                </span>
                                            </v-tooltip>
                                            <v-btn
                                                v-if="editingPrecioIndex !== null"
                                                color="grey"
                                                text
                                                @click="cancelEditPrecio"
                                            >
                                                Cancelar edición
                                            </v-btn>
                                        </v-col>

                                        <v-col cols="12">
                                            <v-row>
                                                <v-col
                                                    cols="12"
                                                    md="12"
                                                    v-for="(precio, index) in producto.producto_precios"
                                                    :key="precio.id ?? index"
                                                    v-if="precio.show"
                                                >
                                                    <v-chip
                                                        outlined
                                                        large
                                                        close
                                                        @click:close="
                                                            removePrecioProducto(
                                                                precio
                                                            )
                                                        "
                                                        class="ma-1"
                                                        :color="
                                                            editingPrecioIndex ===
                                                            index
                                                                ? 'primary'
                                                                : 'green'
                                                        "
                                                        style="width: 100%; min-height: 100px; height: auto;"
                                                    >
                                                        <div
                                                            class="d-flex flex-column"
                                                            style="width: 100%; padding: 16px;"
                                                        >
                                                            <div
                                                                class="d-flex align-center justify-space-between mb-2"
                                                            >
                                                                <span
                                                                    class="font-weight-bold"
                                                                    style="font-size: 1.1em;"
                                                                    >{{
                                                                        precio.descripcion ||
                                                                        "Tarifa"
                                                                    }}</span
                                                                >
                                                                <v-btn
                                                                    icon
                                                                    small
                                                                    @click.stop="
                                                                        startEditPrecio(
                                                                            precio,
                                                                            index
                                                                        )
                                                                    "
                                                                    :title="'Editar tarifa'"
                                                                >
                                                                    <v-icon
                                                                        small
                                                                    >
                                                                        mdi-pencil
                                                                    </v-icon>
                                                                </v-btn>
                                                            </div>
                                                            <div
                                                                class="d-flex"
                                                                style="
                                                                    gap: 15px;
                                                                    flex-wrap: nowrap;
                                                                    white-space: nowrap;
                                                                    overflow-x: auto;
                                                                "
                                                            >
                                                                <span>
                                                                    <strong>Precio:</strong>
                                                                    {{ formatPrice(precio.precio) }}€
                                                                </span>
                                                                <span
                                                                    v-if="
                                                                        precio.precio_anual &&
                                                                        Number(precio.precio_anual) >
                                                                            0
                                                                    "
                                                                >
                                                                    <strong>Precio Anual:</strong>
                                                                    {{ formatPrice(precio.precio_anual) }}€
                                                                </span>
                                                                <span v-if="precio.min_usuarios">
                                                                    <strong>Mín Usuarios:</strong>
                                                                    {{ precio.min_usuarios }}
                                                                </span>
                                                                <span v-if="precio.num_max_usuarios">
                                                                    <strong>Máx Usuarios:</strong>
                                                                    {{ precio.num_max_usuarios }}
                                                                </span>
                                                                <span>
                                                                    <strong>Tipo:</strong>
                                                                    {{
                                                                        precio.fijo
                                                                            ? "Fijo"
                                                                            : "Variable"
                                                                    }}
                                                                </span>
                                                                <span v-if="precio.pago_unico">
                                                                    <strong>Pago Único:</strong> Sí
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </v-chip>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions class="d-flex justify-center">
                <router-link
                    :to="{
                        path: '/lista-producto',
                    }"
                    class="action-buttons"
                >
                    <v-btn color="red" class="white--text mr-2">
                        Cancelar
                    </v-btn>
                </router-link>

                <v-btn
                    v-if="!producto.id"
                    :disabled="isLoading"
                    color="success"
                    class="white--text"
                    @click="saveProducto"
                    >Guardar</v-btn
                >
                <v-btn
                    @click="saveProducto"
                    v-if="producto.id"
                    :disabled="isLoading"
                    color="success"
                    class="white--text"
                    >Actualizar</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import { rules } from "../../../utils/rules";
import { formatPrice } from "../../../utils/formatters";
export default {
    data() {
        return {
            rules: rules,
            formValid: false,
            formValid_precios: false,
            proyectos: [],
            modulos: [],
            producto: {
                id: null,
                nombre: "",
                precio: 0,
                minutos: 0,
                id_modulo: null,
                descripcion: "",
                activo: true,
                producto_precios: [],
            },
            producto_precio: {
                id: null,
                descripcion: "",
                precio: 0,
                precio_anual: 0,
                min_usuarios: null,
                fijo: true,
                pago_unico: false,
                num_max_usuarios: null,
                show: true,
            },
            editingPrecioIndex: null,
        };
    },
    watch: {
        //
    },
    mounted() {
        this.getModulos();
    },
    created() {
        if (this.$route.query.id) {
            this.getProducto(this.$route.query.id);
        }
    },
    methods: {
        getModulos() {
            const self = this;
            axios.get(`api/get-productos-modulos`).then(function (response) {
                self.modulos = response.data;
            });
        },
        getProducto(id) {
            const self = this;
            axios.get(`api/get-producto/${id}`).then(function (response) {
                const producto = { ...response.data };
                if (!Array.isArray(producto.producto_precios)) {
                    producto.producto_precios = [];
                }
                producto.producto_precios = producto.producto_precios.map(
                    (item) => ({
                        ...item,
                        show: item.show !== undefined ? item.show : true,
                    })
                );
                self.producto = producto;
            });
        },
        saveProducto() {
            const self = this;

            if (!self.formValid) {
                self.$toast.error(
                    "Por favor, complete todos los campos requeridos"
                );
                return;
            }

            axios
                .post("api/save-producto", this.producto)
                .then(function (response) {
                    self.$router.push("lista-producto");
                });
        },
        addPrecioProducto() {
            this.$refs.formPrecios.validate();
            if (!this.formValid_precios) {
                return;
            }

            if (this.producto.producto_precios == null) {
                this.producto.producto_precios = [];
            }
            const nuevoPrecio = {
                ...this.producto_precio,
                show:
                    this.producto_precio.show !== undefined
                        ? this.producto_precio.show
                        : true,
            };
            if (this.editingPrecioIndex !== null) {
                this.$set(
                    this.producto.producto_precios,
                    this.editingPrecioIndex,
                    nuevoPrecio
                );
            } else {
                this.producto.producto_precios.push(nuevoPrecio);
            }
            this.resetPrecioForm();
        },
        removePrecioProducto(item) {
            item.show = false;
            const index = this.producto.producto_precios.indexOf(item);
            this.producto.producto_precios.splice(index, 1);
        },
        startEditPrecio(precio, index) {
            this.producto_precio = {
                id: precio.id ?? null,
                descripcion: precio.descripcion ?? "",
                precio: precio.precio ?? 0,
                precio_anual: precio.precio_anual ?? 0,
                min_usuarios:
                    precio.min_usuarios !== undefined
                        ? precio.min_usuarios
                        : null,
                fijo:
                    typeof precio.fijo === "boolean" ? precio.fijo : true,
                pago_unico: !!precio.pago_unico,
                num_max_usuarios:
                    precio.num_max_usuarios !== undefined
                        ? precio.num_max_usuarios
                        : null,
                show: precio.show !== undefined ? precio.show : true,
            };
            this.editingPrecioIndex = index;
        },
        cancelEditPrecio() {
            this.resetPrecioForm();
        },
        resetPrecioForm() {
            this.producto_precio = {
                id: null,
                descripcion: "",
                precio: 0,
                precio_anual: 0,
                min_usuarios: null,
                fijo: true,
                pago_unico: false,
                num_max_usuarios: null,
                show: true,
            };
            this.editingPrecioIndex = null;
            if (
                this.$refs.formPrecios &&
                typeof this.$refs.formPrecios.resetValidation === "function"
            ) {
                this.$refs.formPrecios.resetValidation();
            }
        },
        clearForm() {
            this.producto = {
                id: null,
                nombre: "",
                precio: 0,
                minutos: 0,
                id_modulo: null,
                descripcion: "",
                activo: true,
                producto_precios: [],
            };
        },
        formatPrice,
    },
    filters: {
        //
    },
    computed: {
        isLoading: function () {
            return this.$store.getters.getloading;
        },
    },
};
</script>
